export function Separator() {
  return <div className="h-px bg-neutrals-300 w-full" />;
}
